import { render, staticRenderFns } from "./badge-number.vue?vue&type=template&id=1534e19c"
import script from "./badge-number.vue?vue&type=script&lang=js"
export * from "./badge-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports